module.exports = __webpack_public_path__ + "img/t-size-flag.014fe8d.svg";